import i18next from 'i18next';

/** Báo cáo bằng 0 mà ghi chú trống (bỏ thẻ HTML / &nbsp;) → phải nhập ghi chú (lưu ý dưới bảng báo cáo). */
export function isZeroReportWithoutNote(hoanThanh: number | null | undefined, content: string | null | undefined): boolean {
  if (hoanThanh == null || Number(hoanThanh) !== 0) return false;
  const text = String(content ?? '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').trim();
  return text.length === 0;
}

export function zeroReportNoteMessage(record: { date?: string | null }, index: number): string {
  return i18next.t('bsc.msg.baocao0canghichu', 'Báo cáo bằng 0 cần nhập ghi chú (kỳ {{ky}}).', {
    ky: String(record.date || index + 1),
  });
}
